import React from "react";
import moment from "moment";
import styles from "./Realtime.css";
import Clock from "../../images/ic-clock.svg";
import Check from "../../images/ic-check.svg";
import ChevronDown from "../../images/ic-chevron-down.svg";

interface Props {
  isRealTimeUpdated: boolean;
  lastUpdatedTime: number;
  onClickChevronDown: () => void;
}

const formatTime = (time: number): string => {
  return time >= 10 ? String(time) : "0" + time;
};

const textFormattedTime = (time: number) => {
  const dateTime = moment(time);
  const hour = dateTime.hour();
  const minutes = dateTime.minute();

  return formatTime(hour) + ":" + formatTime(minutes);
};

const getContent = (isRealTimeUpdated: boolean, lastUpdatedTime: number) => {
  if (isRealTimeUpdated) {
    return (
      <>
        <Check className={styles.icon} />
        Atualizando a previsão em tempo real
      </>
    );
  }

  return (
    <>
      <Clock className={styles.icon} />
      {`Posição do veículo atualizada às ${textFormattedTime(lastUpdatedTime)}`}
    </>
  );
};
export const Realtime = ({
  isRealTimeUpdated,
  lastUpdatedTime,
  onClickChevronDown
}: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {getContent(isRealTimeUpdated, lastUpdatedTime)}
      </div>
      <ChevronDown
        onClick={onClickChevronDown}
        className={styles.chevronDown}
      />
    </div>
  );
};
